// extracted by mini-css-extract-plugin
export var backdropBlur = "_fu-0";
export var contentCard = "_fu-5";
export var frame = "_fu-2";
export var image = "_fu-4";
export var imagePane = "_fu-3";
export var modal = "_fu-1";